<template>
  <div>
    <div class="d-flex">
      <div class="text-subtitle-2 font-weight-bold" v-html="label"></div>
      <div class="caption ml-2 fgrey--text" v-html="info"></div>
    </div>

    <div v-if="currency == true" class="--label pt-6">{{ $n(total,'currency')  }} </div>
    <div v-else class="--label pt-6">{{ $n(total)}} </div>

    <!-- <div class="text-caption blue--text">No período</div> -->
    <GChart v-if="done" :type="type" :data="chartData" :options="options" />
  </div>
</template>
  
<script>

import { chartType, chartOptions } from './DashGraphChartData';

export default {
  name: 'DashGraph',
  data() {
    return {
      loading: true,
      type: chartType,
      options: chartOptions,
      done: false
    };
  },
  props: {
    label: String,
    info: String,
    dataChart: Object,
    currency: Boolean
  },
  mounted(){
    setTimeout(() => {
          this.done = true
      },100)
  },
  computed: {
    total() {
      if (this.dataChart && this.dataChart.values) {
        let init = 0
        return this.dataChart.values.reduce((total, current) => total += current, init)
      }
      return 0
    },
    chartData() {
      if (this.dataChart && this.dataChart.labels) {

        const dataChart = [['', '']]
        const l = this.dataChart.labels.length

        for (let i = 0; i < l - 1; i++) {
          dataChart.push([this.dataChart.labels[i], this.dataChart.values[i]])
        }
        return dataChart
      }
      else {
        return []
      }
    }

  }
};
</script>

<style lang="scss">
.--label {
  font-size: 24px;
  color: #fff;
  line-height: 18px;
  margin-bottom: 6px;
  color: #000;
  font-weight: bold;
}
</style>
  